import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function RequiredFieldMessage({
  handleClick,
  show,
  reqMessage,
  hasButton,
  fieldMessage,
}) {
  const { t } = useTranslation();
  return (
    <Alert className="text-start" key="danger" variant="danger" show={show}>
      {fieldMessage ? (
        <strong>
          <p className="mb-0">{t("messages.completeRequiredFields")}</p>
        </strong>
      ) : (
        <strong>
          <p>{t("messages.pageRequirementsNotMet")}</p>
        </strong>
      )}

      {reqMessage && <p>{reqMessage}</p>}

      {hasButton && (
        <>
          <hr />
          <p>{t("messages.skipStepInfo")}</p>
          <Button variant="link" onClick={handleClick}>
            {t("common.skipThisStep")}
          </Button>
        </>
      )}
    </Alert>
  );
}
